import.meta.glob('../images/**/*', { eager: true })

import Rails from '@rails/ujs'
if (!window._rails_loaded) Rails.start()

import $ from 'jquery'
window.jQuery = window.$ = $

import 'popper.js'
import 'bootstrap'

import '../src/typeahead.js'
import '../src/custom.js'

import subsidies from '../src/pages/subsidies.svelte'
import SubsidyPreview from '../src/components/SubsidyPreview.svelte'

const components = { subsidies, SubsidyPreview }

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-svelte-component]').forEach(el => {
    const Component = components[el.dataset.svelteComponent]
    if (!Component) return
    const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
    new Component({ target: el, props })
  })

  document.querySelectorAll('.load-after-svelte').forEach(el => {
    el.style.display = 'contents'
  })
})
